import { PermitFieldType } from '~/client/graph'

export const CLOSURE_FIELD_TYPES = [
  PermitFieldType.Location,
  PermitFieldType.LocationInformational,
  PermitFieldType.Equipment,
  PermitFieldType.EquipmentInformational,
]
